// extracted by mini-css-extract-plugin
export default {"notFound":"notFound_notFound__YXFre","notFound_title":"notFound_notFound_title__LcksI","notFound_desc":"notFound_notFound_desc__JDaqF","Shimiring":"notFound_Shimiring__Ho+tW"};